import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FormHelperText, InputLabel } from '@mui/material';
import { AsyncAutoCompleteProps } from './types';
import styles from './styles';

export default function AsyncAutoComplete<T>({
    async,
    optionLabel,
    id,
    label,
    defaultValue,
    handleSelectedoption,
    disabled,
    error,
    errorMessage,
}: AsyncAutoCompleteProps<T>) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState<readonly T[]>([]);
    const [inputValue, setInputValue] = React.useState<string>(
        defaultValue && defaultValue[optionLabel] ? (defaultValue[optionLabel] as unknown as string) : '',
    );

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    return (
        <Autocomplete
            id={id}
            sx={styles.autoComplete}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            defaultValue={defaultValue}
            inputValue={inputValue}
            isOptionEqualToValue={(option, value) => option[optionLabel] === value[optionLabel]}
            getOptionLabel={(option) => (option[optionLabel] as unknown as string) || ''}
            options={options}
            onChange={(_event, selectedoption) => {
                handleSelectedoption(selectedoption);
                setInputValue(selectedoption ? (selectedoption[optionLabel] as unknown as string) : '');
            }}
            renderInput={(params) => (
                <>
                    <InputLabel htmlFor={label} sx={error ? { ...styles.label, color: '#ED0000' } : styles.label}>
                        {label}
                    </InputLabel>
                    <TextField
                        {...params}
                        onChange={async (event) => {
                            const { value } = event.target;
                            setInputValue(value);
                            if (event.target.value.length >= 3 || value.length === 0) {
                                const result = await async(value);
                                console.log('result', result);
                                setOptions(result);
                            } else {
                                setOptions([]);
                            }
                        }}
                        InputProps={{
                            ...params.InputProps,
                            sx: {
                                borderRadius: '16px',
                                fontFamily: 'Silka_Semi_Bold',
                                fontWeight: 600,
                                fontSize: '16px',
                                lineHeight: '21px',
                                color: '#001533',
                            },
                        }}
                        placeholder="Select..."
                        error={error}
                    />
                    <FormHelperText sx={styles.error_message}>{errorMessage}</FormHelperText>
                </>
            )}
            disabled={disabled}
        />
    );
}
